
import Vue from "vue";
import store from "@/store";
import router from "@/router";
import AppLoading from "@/components/UI/AppLoading.vue";

export default Vue.extend({
  name: "AdminAllCategories",
  components: { AppLoading },
  computed: {
    categories(): any[] {
      const categories = store.state.panel.categories;
      return categories.filter((category: any) => category.parent === null);
    },
    subCategories(): any[] {
      const categories = store.state.panel.categories;
      return categories.filter((category: any) => category.parent !== null);
    },
  },
  methods: {
    editCategory(id: string): void {
      router.push({ name: "admin-edit-category", query: { id: id } });
    },
  },
});
